var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLightbulb01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightbulb-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 3.15828C6.16165 3.15828 4.66927 4.65067 4.66927 6.49162C4.66927 7.85746 5.49085 9.0329 6.66952 9.54788C6.91234 9.65397 7.06927 9.8938 7.06927 10.1588V12.4916C7.06927 12.5653 7.12897 12.625 7.2026 12.625H8.8026C8.87624 12.625 8.93594 12.5653 8.93594 12.4916V10.0916C8.93594 9.82663 9.09287 9.58681 9.33569 9.48072C10.5267 8.96032 11.3359 7.84455 11.3359 6.49162C11.3359 4.65067 9.84355 3.15828 8.0026 3.15828ZM3.33594 6.49162C3.33594 3.91429 5.42528 1.82495 8.0026 1.82495C10.5799 1.82495 12.6693 3.91429 12.6693 6.49162C12.6693 8.25801 11.6907 9.72348 10.2693 10.5057V12.4916C10.2693 13.3016 9.61262 13.9583 8.8026 13.9583H7.2026C6.39259 13.9583 5.73594 13.3016 5.73594 12.4916V10.5716C4.30533 9.77522 3.33594 8.24725 3.33594 6.49162ZM6.13594 7.29162C6.13594 6.92343 6.43441 6.62495 6.8026 6.62495H9.2026C9.57079 6.62495 9.86927 6.92343 9.86927 7.29162C9.86927 7.65981 9.57079 7.95828 9.2026 7.95828H6.8026C6.43441 7.95828 6.13594 7.65981 6.13594 7.29162ZM5.73594 15.2916C5.73594 14.9234 6.03441 14.625 6.4026 14.625H9.6026C9.97079 14.625 10.2693 14.9234 10.2693 15.2916C10.2693 15.6598 9.97079 15.9583 9.6026 15.9583H6.4026C6.03441 15.9583 5.73594 15.6598 5.73594 15.2916Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLightbulb01);
export default __webpack_public_path__ + "static/media/ic-lightbulb-01.fbcb3f95549dc82d0b8a10cf4384afe6.svg";
export { ForwardRef as ReactComponent };